// extracted by mini-css-extract-plugin
export var actions = "_48-0";
export var actionsContainer = "_48-6";
export var border = "_48-1";
export var childFullHeight = "_48-d";
export var collapse = "_48-2";
export var content = "_48-8";
export var contentChild = "_48-c";
export var fullscreen = "_48-a";
export var headerContainer = "_48-3";
export var headerRow = "_48-5";
export var hidePadding = "_48-9";
export var noScrollX = "_48-e";
export var noScrollY = "_48-f";
export var optOutTopPadding = "_48-b";
export var pagePadding = "_48-7";
export var profile = "_48-g";
export var profileContainer = "_48-h";
export var profileImage = "_48-i";
export var profileMain = "_48-j";
export var profileSubtitle = "_48-l";
export var profileTitle = "_48-k";
export var tabsWrapper = "_48-4";
export var title = "_48-m";